<template>
  <div>
    <!-- Print Invoice  -->
    <div class="">
      <iframe id="iframeReceipt" name="iframeReceipt" style="height:0;width:0;"></iframe>
      <section ref="invoice" style="display:none;" id="printableArea">
        <div>
          <center>
            TAX INVOICE
          </center>
        </div>
        <table width="100%" cellspacing="0" style="">
          <tr>
            <td align="left" width="50%">
              <span class="franchiseeTable">To,</span><br />
              <span class="franchiseeTable">{{ franchiseeDetails.companyName ? franchiseeDetails.companyName : '' }}</span
              ><br />
              <span class="franchiseeTable"><b>Trust Name :</b> {{ this.franchiseeDetails.trustName ? this.franchiseeDetails.trustName : '' }}</span
              ><br />
              <span class="franchiseeTable"
                ><b>Address :</b> {{ this.franchiseeDetails.address1 ? this.franchiseeDetails.address1 : '' }}&nbsp;&nbsp;{{
                  this.franchiseeDetails.city ? this.franchiseeDetails.city : ''
                }}&nbsp;&nbsp;{{ this.franchiseeDetails.state ? this.franchiseeDetails.state : '' }}&nbsp;&nbsp;{{ this.franchiseeDetails.pincode ? this.franchiseeDetails.pincode : '' }} </span
              ><br />
              <span class="franchiseeTable"><b>GST No. :</b> {{ this.franchiseeDetails.gstNo ? this.franchiseeDetails.gstNo : '' }}</span
              ><br />
              <span class="franchiseeTable"><b>Place Of Supply :</b> {{ this.franchiseeDetails.state ? this.franchiseeDetails.state : '' }}</span
              ><br />
              <span class="franchiseeTable"><b>Contact No. :</b> {{ this.franchiseeDetails.mobileno ? this.franchiseeDetails.mobileno : '' }}</span
              ><br />

              <span class="franchiseeTable"><b>Invoice No. :</b> {{ invoiceInfo.invoiceNo ? invoiceInfo.invoiceNo : '' }}</span
              ><br />

              <span class="franchiseeTable"><b>Invoice Date :</b> {{ invoiceInfo.invoiceDate ? new Date(invoiceInfo.invoiceDate).toLocaleDateString() : '' }}</span
              ><br />
            </td>
            <td align="right" width="50%">
              <br />
              <span class="franchiseeTable"><img  alt="logo" :src="logoUrl"/></span><br />
              <span class="franchiseeTable"> {{ conditionalCompanyName(invoiceInfo.invoiceDate) }} </span><br />
              <span class="franchiseeTable"><b></b> Rajashree Business Park, Plot No 114,Survey No.338, Next to Sohrabh hall, Tadiwala Road,Pune 411001</span><br /><br />

            </td>
          </tr>
        </table>

        <br />
        <table class="invoiceTable">
          <thead>
            <tr>
              <td class="has-text-left has-text-weight-bold" rowspan="2">Enrollment Code</td>
              <td class="has-text-left has-text-weight-bold" rowspan="2" width="150">Student Details</td>
              <td class="has-text-left has-text-weight-bold" rowspan="2" width="150">Student Communication</td>
              <td class="has-text-left has-text-weight-bold" rowspan="2">SAC/HSN Code</td>
              <td class="has-text-left has-text-weight-bold" rowspan="2">Taxable Value</td>

              <td v-if="this.invoiceInfo && this.invoiceInfo.royaltyGSTType === 'IGST'" class="has-text-left has-text-weight-bold" rowspan="2">
                <table style="border-collapse: collapse;">
                  <tr>
                    <td colspan="2" align="center">IGST</td>
                  </tr>
                  <tr>
                    <td align="center">Rate</td>
                    <td align="center">Amount</td>
                  </tr>
                </table>
              </td>
              <td v-if="this.invoiceInfo && this.invoiceInfo.royaltyGSTType === 'CGST-SGST'" class="has-text-left has-text-weight-bold" rowspan="2">
                <table style="border-collapse: collapse;">
                  <tr>
                    <td colspan="2" align="center">CGST</td>
                  </tr>
                  <tr>
                    <td align="center">Rate</td>
                    <td align="center">Amount</td>
                  </tr>
                </table>
              </td>
              <td v-if="this.invoiceInfo && this.invoiceInfo.royaltyGSTType === 'CGST-SGST'" class="has-text-left has-text-weight-bold" rowspan="2">
                <table style="border-collapse: collapse;">
                  <tr>
                    <td colspan="2" align="center">SGST</td>
                  </tr>
                  <tr>
                    <td align="center">Rate</td>
                    <td align="center">Amount</td>
                  </tr>
                </table>
              </td>
              <td class="has-text-left has-text-weight-bold" rowspan="2">Total(including Tax)</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="has-text-right">{{ invoiceInfo.enrollmentCode ? invoiceInfo.enrollmentCode : '' }}</td>
              <td v-if="studentDetails" class="has-text-right">
                <strong>{{ this.studentDetails && this.studentDetails.studentName ? this.studentDetails.studentName : '' }}</strong> |&nbsp;&nbsp;
                {{ invoiceInfo.studentDetails && invoiceInfo.studentDetails.class ? invoiceInfo.studentDetails.class : '' }} |&nbsp;&nbsp;{{
                  this.studentDetails && this.studentDetails.fatherEmailID ? this.studentDetails.fatherEmailID : ''
                }}| &nbsp;Amount&nbsp;&nbsp; {{ invoiceInfo && invoiceInfo.amount ? invoiceInfo.amount : '' }} || &nbsp;Royalty %: &nbsp;&nbsp;
                {{ invoiceInfo && invoiceInfo.royaltyPercentage ? invoiceInfo.royaltyPercentage : '' }} |&nbsp;&nbsp;{{
                  invoiceInfo.studentDetails && invoiceInfo.studentDetails.franchiseeAcademicYear && invoiceInfo.studentDetails.franchiseeAcademicYear.academicYear
                    ? invoiceInfo.studentDetails.franchiseeAcademicYear.academicYear
                    : ''
                }}
              </td>
              <td v-if="studentDetails" class="has-text-right">
                <strong>{{ this.studentDetails && this.studentDetails.address ? this.studentDetails.address : '' }}</strong> |&nbsp;&nbsp;
                {{ this.studentDetails && this.studentDetails.city ? this.studentDetails.city : '' }} |&nbsp;&nbsp;
                {{ this.studentDetails && this.studentDetails.pincode ? this.studentDetails.pincode : '' }} &nbsp;Contact No&nbsp;&nbsp;
                {{ this.studentDetails && this.studentDetails.fatherMobile ? this.studentDetails.fatherMobile : '' }} |&nbsp;&nbsp;{{
                  this.studentDetails && this.studentDetails.fatherEmailID ? this.studentDetails.fatherEmailID : ''
                }}
              </td>

              <td class="has-text-right">{{ invoiceInfo.hsnCode ? invoiceInfo.hsnCode : '' }}</td>
              <td class="has-text-right"><small class="rupeeSign">&#x20b9;</small>{{ invoiceInfo.amount ? invoiceInfo.amount : '' }}</td>
              <td v-if="invoiceInfo.royaltyGSTType === 'IGST'" class="has-text-right">
                <table style="border-collapse: collapse;">
                  <tr>
                    <td align="center">{{ invoiceInfo.royaltyIGST ? invoiceInfo.royaltyIGST : '' }}%</td>
                    <td align="center"><small class="rupeeSign">&#x20b9;</small>{{ invoiceInfo.royaltyIGST ? ((invoiceInfo.royaltyIGST * invoiceInfo.amount) / 100).toFixed(2) : '' }}</td>
                  </tr>
                </table>
              </td>
              <td v-if="invoiceInfo.royaltyGSTType === 'CGST-SGST'" class="has-text-right">
                <table style="border-collapse: collapse;">
                  <tr>
                    <td align="center">{{ invoiceInfo.royaltyCGST ? invoiceInfo.royaltyCGST : '' }}%</td>
                    <td align="center"><small class="rupeeSign">&#x20b9;</small>{{ invoiceInfo.royaltyCGST ? ((invoiceInfo.royaltyCGST * invoiceInfo.amount) / 100).toFixed(2) : '' }}</td>
                  </tr>
                </table>
              </td>
              <td v-if="invoiceInfo.royaltyGSTType === 'CGST-SGST'" class="has-text-right">
                <table style="border-collapse: collapse;">
                  <tr>
                    <td align="center">{{ invoiceInfo.royaltySGST ? invoiceInfo.royaltySGST : '' }}%</td>
                    <td align="center"><small class="rupeeSign">&#x20b9;</small>{{ invoiceInfo.royaltySGST ? ((invoiceInfo.royaltySGST * invoiceInfo.amount) / 100).toFixed(2) : '' }}</td>
                  </tr>
                </table>
              </td>
              <td class="has-text-right">
                <div v-if="invoiceInfo.royaltyGSTType === 'IGST'">
                  <small class="rupeeSign">&#x20b9;</small> {{ invoiceInfo.amount ? (Number(invoiceInfo.amount) + (invoiceInfo.royaltyIGST * invoiceInfo.amount) / 100).toFixed(2) : '' }}
                </div>
                <div v-if="invoiceInfo.royaltyGSTType === 'CGST-SGST'">
                  <small class="rupeeSign">&#x20b9;</small>
                  {{ invoiceInfo.amount ? (Number(invoiceInfo.amount) + (invoiceInfo.royaltySGST * invoiceInfo.amount) / 100 + (invoiceInfo.royaltyCGST * invoiceInfo.amount) / 100).toFixed(2) : '' }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <br /><br />
        <div class="franchiseeTable">
          <div>
            <b>{{invoiceInfo.royaltyGSTType === 'IGST'? 'Total IGST Amount :': invoiceInfo.royaltyGSTType === 'CGST-SGST' ? 'Total CGST + SGST Amount :' :''}}</b>
            <span>
              <span class="font-weight-normal" v-if="invoiceInfo.royaltyGSTType === 'IGST'"
                ><small class="rupeeSign">&#x20b9;</small>{{ invoiceInfo.royaltyIGST ? ((invoiceInfo.royaltyIGST * invoiceInfo.amount) / 100).toFixed(2) : '' }}</span
              >
              <span class="font-weight-normal" v-if="invoiceInfo.royaltyGSTType === 'CGST-SGST'"
                ><small class="rupeeSign">&#x20b9;</small
                >
                {{ invoiceInfo.royaltyCGST ? (Number((Number(invoiceInfo.royaltyCGST)) + (Number(invoiceInfo.royaltySGST))) * (Number(invoiceInfo.amount))/100).toFixed(2) : '' }}</span
              ></span
            >
          </div>
          <br />
          <div>
            <b>Grand Total:</b>
            <span>
              <span class="font-weight-normal" v-if="invoiceInfo.royaltyGSTType === 'IGST'">
                <small class="rupeeSign">&#x20b9;</small
                >{{ invoiceInfo.royaltyIGST ? (Number(invoiceInfo.amount) + Number(((invoiceInfo.royaltyIGST * invoiceInfo.amount) / 100).toFixed(2))).toFixed(2) : '' }}</span
              >
              <span class="font-weight-normal" v-if="invoiceInfo.royaltyGSTType === 'CGST-SGST'">
                <small class="rupeeSign">&#x20b9;</small
                >

                {{ invoiceInfo.amount ? (Number(invoiceInfo.amount) + (invoiceInfo.royaltySGST * invoiceInfo.amount) / 100 + (invoiceInfo.royaltyCGST * invoiceInfo.amount) / 100).toFixed(2) : '' }}
              </span></span
            >
          </div>
          <br />
          <div><b>GST NO.:</b> <span>27AAECB1042N1ZQ</span></div>
          <br />
          <div><b>Registered Office:</b> Rajashree Business Park, Plot No 114,Survey No.338, Next to Sohrabh hall, Tadiwala Road,Pune 411001</div>
          <br />
          <div><b>CIN:</b> U72100PN2010PTC136340</div>
        </div>
        <div style="margin-right: 30px; margin-top: 100px;" align="right"><b>Signature</b></div>
        <v-layout v-if="invoiceDetail.image" justify-center>
          <v-flex shrink>
            <div><img v-bind:src="invoiceDetail.image" /></div>
          </v-flex>
        </v-layout>
      </section>
    </div>
    <v-container fluid>
      <material-card icon="mdi-file-document" inline title="Royalty Invoice">
        <v-btn title="Print" @click="printInvoice()" elevation="1" absolute right top> <v-icon left>mdi-printer</v-icon>Print</v-btn>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" md="6">
                <v-card-component>
                  <div class="subtitle font-weight-medium mb-3">To,</div>
                  <v-simple-table>
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <div class="body-1">
                            <strong>{{ this.franchiseeDetails.companyName ? this.franchiseeDetails.companyName : '' }}</strong>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Trust Name.</td>
                        <td>{{ this.franchiseeDetails.trustName ? this.franchiseeDetails.trustName : '' }}</td>
                      </tr>
                      <tr>
                        <td>Address</td>
                        <td>
                          {{ this.franchiseeDetails.address1 ? this.franchiseeDetails.address1 : '' }}&nbsp;&nbsp;{{ this.franchiseeDetails.city ? this.franchiseeDetails.city : '' }}&nbsp;&nbsp;{{
                            this.franchiseeDetails.state ? this.franchiseeDetails.state : ''
                          }}&nbsp;&nbsp;{{ this.franchiseeDetails.pincode ? this.franchiseeDetails.pincode : '' }}
                        </td>
                      </tr>
                      <tr>
                        <td>GST No.</td>
                        <td>{{ this.franchiseeDetails.gstNo ? this.franchiseeDetails.gstNo : '' }}</td>
                      </tr>
                      <tr>
                        <td>Contact No</td>
                        <td>{{ this.franchiseeDetails.mobileno ? this.franchiseeDetails.mobileno : '' }}</td>
                      </tr>
                      <tr>
                        <td>Place of Supply</td>
                        <td>{{ this.franchiseeDetails.state ? this.franchiseeDetails.state : '' }}</td>
                      </tr>

                      <tr>
                        <td>Invoice No.</td>
                        <td>{{ invoiceInfo.invoiceNo ? invoiceInfo.invoiceNo : '' }}</td>
                      </tr>

                      <tr>
                        <td>Invoice Date</td>
                        <td>{{ invoiceInfo.invoiceDate ? new Date(invoiceInfo.invoiceDate).toLocaleDateString() : '' }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-component>
              </v-col>
              <v-col cols="12" md="6">
                <v-card-component>
                  <v-img width="150" class="mb-5" :src="logoUrl"></v-img>
                  <v-card-title class="text-decoration-underline">Billing Address</v-card-title>
                  <v-simple-table>
                    <tbody>
                      <tr>
                        <td class="font-weight-bold body-2 subtitle"></td>
                        <td>
                          {{ conditionalCompanyName(invoiceInfo.invoiceDate) }}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold body-2 subtitle"></td>
                        <td>
                          Rajashree Business Park, Plot No 114,Survey No.338, Next to Sohrabh hall, Tadiwala Road,Pune 411001
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-component>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card-component>
          <v-divider class=" my-0 " />
          <v-data-table
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            hide-default-footer
            :items-per-page="10"
            :headers="headers"
            :items="rawData"
          >
            <template v-slot:item.studentName="{ item }">
              <strong>{{
                item.studentDetails && item.studentDetails.studentEnrollment && item.studentDetails.studentEnrollment.studentName ? item.studentDetails.studentEnrollment.studentName : ''
              }}</strong>
              |&nbsp;&nbsp; {{ item.studentDetails && item.studentDetails.class ? item.studentDetails.class : '' }} |&nbsp;&nbsp;{{
                item.studentDetails && item.studentDetails.studentEnrollment ? item.studentDetails.studentEnrollment.fatherEmailID : ''
              }}
              |&nbsp;&nbsp;{{
                item.studentDetails && item.studentDetails.franchiseeAcademicYear && item.studentDetails.franchiseeAcademicYear.academicYear
                  ? item.studentDetails.franchiseeAcademicYear.academicYear
                  : ''
              }}| &nbsp;Amount&nbsp;&nbsp; {{ item.amount ? item.amount : '' }} | &nbsp;Royalty %: &nbsp;&nbsp; {{ item.royaltyPercentage ? item.royaltyPercentage : '' }}
            </template>

            <template v-slot:item.address="{ item }">
              <strong>{{ item.studentDetails && item.studentDetails.studentEnrollment && item.studentDetails.studentEnrollment.address ? item.studentDetails.studentEnrollment.address : '' }}</strong>
              |&nbsp;&nbsp; {{ item.studentDetails && item.studentDetails.studentEnrollment && item.studentDetails.studentEnrollment.city ? item.city : '' }} |&nbsp;&nbsp;
              {{ item.studentDetails && item.studentDetails.studentEnrollment && item.studentDetails.studentEnrollment.pincode ? item.studentDetails.studentEnrollment.pincode : '' }} &nbsp;Contact
              No&nbsp;&nbsp;
              {{ item.studentDetails && item.studentDetails.studentEnrollment && item.studentDetails.studentEnrollment.fatherMobile ? item.studentDetails.studentEnrollment.fatherMobile : '' }}
              |&nbsp;&nbsp;{{
                item.studentDetails && item.studentDetails.studentEnrollment && item.studentDetails.studentEnrollment.fatherEmailID ? item.studentDetails.studentEnrollment.fatherEmailID : ''
              }}
            </template>

            <template v-slot:item.includeTax="{ item }">
              <div v-if="invoiceInfo.royaltyGSTType === 'IGST'">
                <small class="rupeeSign">&#x20b9;</small> {{ item.amount ? (Number(item.amount) + (item.royaltyIGST * item.amount) / 100).toFixed(2) : '' }}
              </div>
              <div v-if="invoiceInfo.royaltyGSTType === 'CGST-SGST'">
                <small class="rupeeSign">&#x20b9;</small> {{ item.amount ? (Number(item.amount) + (item.royaltySGST * item.amount) / 100 + (item.royaltyCGST * item.amount) / 100).toFixed(2) : '' }}
              </div>
            </template>

            <template v-if="invoiceInfo.royaltyGSTType === 'CGST-SGST'" v-slot:item.CGST="{ item }">
              <tr>
                <td class="px-3 py-1">
                  <span>Rate:</span> <span>{{ item.royaltyCGST ? item.royaltyCGST : '' }}%</span>
                </td>
                <td class="px-3 py-1">
                  <span>Amount:</span><small class="rupeeSign">&#x20b9;</small> <span>{{ item.royaltyCGST ? ((item.royaltyCGST * item.amount) / 100).toFixed(2) : '' }}</span>
                </td>
              </tr>
            </template>

            <template v-if="invoiceInfo.royaltyGSTType === 'CGST-SGST'" v-slot:item.SGST="{ item }">
              <tr>
                <td class="px-3 py-1">
                  <span>Rate:</span> <span>{{ item.royaltySGST ? item.royaltySGST : '' }}%</span>
                </td>
                <td class="px-3 py-1">
                  <span>Amount:</span><small class="rupeeSign">&#x20b9;</small> <span>{{ item.royaltySGST ? ((item.royaltySGST * item.amount) / 100).toFixed(2) : '' }}</span>
                </td>
              </tr>
            </template>

            <template v-if="invoiceInfo.royaltyGSTType === 'IGST'" v-slot:item.IGST="{ item }">
              <tr>
                <td class="px-3 py-1">
                  <span>Rate:</span> <span>{{ item.royaltyIGST ? item.royaltyIGST : '' }}%</span>
                </td>
                <td class="px-3 py-1">
                  <span>Amount:</span> <small class="rupeeSign">&#x20b9;</small><span>{{ item.royaltyIGST ? ((item.royaltyIGST * item.amount) / 100).toFixed(2) : '' }}</span>
                </td>
              </tr>
            </template>

            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
          <v-card-subtitle class="pb-0">
            <span class="font-weight-bold mr-2">
              {{invoiceInfo.royaltyGSTType === 'IGST'? 'Total IGST Amount :': invoiceInfo.royaltyGSTType === 'CGST-SGST' ? 'Total CGST + SGST Amount :' :''}}
              </span>
            <span class="font-weight-normal" v-if="invoiceInfo.royaltyGSTType === 'IGST'"
              ><small class="rupeeSign">&#x20b9;</small>{{ invoiceInfo.royaltyIGST ? ((invoiceInfo.royaltyIGST * invoiceInfo.amount) / 100).toFixed(2) : '' }}</span
            >
            <span class="font-weight-normal" v-if="invoiceInfo.royaltyGSTType === 'CGST-SGST'"
              ><small class="rupeeSign">&#x20b9;</small
              >

              {{ invoiceInfo.royaltyCGST ? (Number((Number(invoiceInfo.royaltyCGST)) + (Number(invoiceInfo.royaltySGST))) * (Number(invoiceInfo.amount))/100).toFixed(2) : '' }}
              </span
            >
          </v-card-subtitle>
          <v-card-subtitle class="pb-0">
            <span class="font-weight-bold mr-2">Grand Total :</span>
            <span class="font-weight-normal" v-if="invoiceInfo.royaltyGSTType === 'IGST'">
              <small class="rupeeSign">&#x20b9;</small
              >{{ invoiceInfo.royaltyIGST ? (Number(invoiceInfo.amount) + Number(((invoiceInfo.royaltyIGST * invoiceInfo.amount) / 100).toFixed(2))).toFixed(2) : '' }}</span
            >
            <span class="font-weight-normal" v-if="invoiceInfo.royaltyGSTType === 'CGST-SGST'">
              <small class="rupeeSign">&#x20b9;</small
              >

              {{ invoiceInfo.amount ? (Number(invoiceInfo.amount) + (invoiceInfo.royaltySGST * invoiceInfo.amount) / 100 + (invoiceInfo.royaltyCGST * invoiceInfo.amount) / 100).toFixed(2) : '' }}
            </span>
          </v-card-subtitle>
          <v-card-subtitle class="pb-0">
            <span class="font-weight-bold mr-2">GST No :</span>
            <span class="font-weight-normal">27AAECB1042N1ZQ</span>
          </v-card-subtitle>
          <v-card-subtitle class="pb-0">
            <span class="font-weight-bold mr-2">Registered Office : </span>
            <span class="font-weight-normal">Rajashree Business Park, Plot No 114,Survey No.338, Next to Sohrabh hall, Tadiwala Road,Pune 411001</span>
          </v-card-subtitle>
          <v-card-subtitle>
            <span class="font-weight-bold mr-2"> CIN : </span>
            <span class="font-weight-normal">U72100PN2010PTC136340</span>
          </v-card-subtitle>
          <v-row>
            <v-col cols="12 " class="d-flex justify-end">
              <v-card-subtitle class="pb-0 mr-10">
                <span class="font-weight-bold">Signature</span>
              </v-card-subtitle>
            </v-col>
          </v-row>

          <!-- <canvas id="canvas"></canvas> -->
        </v-card-component>
        <v-layout v-if="invoiceDetail.image" justify-center>
          <v-flex shrink>
            <div><img v-bind:src="invoiceDetail.image" /></div>
          </v-flex>
        </v-layout>
        <!-- <v-card class="mx-auto" outlined>
          <div v-if="invoiceDetail.image">
            <section class="align-center">
              <img v-bind:src="invoiceDetail.image" />
            </section>
          </div>
        </v-card> -->
      </material-card>
    </v-container>
  </div>
</template>
<script src="/build/qrcode.min.js"></script>
<script>
// @ is an alias to /src
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import helper from '@/utils/helper'
import QRCode from 'qrcode'
import constants from '@/utils/constants'
// import stores from '@/stores'
// import constants from '@/utils/constants'
// import _ from 'lodash'
export default {
  name: 'royaltyInvoice',
  components: {
    VCardComponent,
    MaterialCard
  },
  props: ['transactionID'],
  data() {
    return {
      franchiseeDetails: {},
      invoiceDetail: {
        image: ''
      },
      logoUrl: 'http://cdn.fcglcdn.com/brainbees/images/n/fc_logo.jpg',
      rawData: [],
      invoiceInfo: '',
      headers: this.getHeaders(),
      studentDetails: {}
    }
  },
  async created() {
    this.logoUrl = await helper.convertImgToBase64(this.logoUrl)
    await this.getInvoiceDetails()
  },
  methods: {
    getHeaders() {
      let headers = [
        { text: 'Enrollment Code', value: 'enrollmentCode' },
        { text: 'Student Details', value: 'studentName' },

        { text: 'Student Communication ', value: 'address' },
        { text: 'SAC/HSN Code', value: 'hsnCode' },

        { text: 'Taxable Value', value: 'amount' }
      ]

      if (this.invoiceInfo && this.invoiceInfo.royaltyGSTType === 'IGST') {
        headers.push({ text: 'IGST', value: 'IGST', align: 'center' })
      }
      if (this.invoiceInfo && this.invoiceInfo.royaltyGSTType === 'CGST-SGST') {
        headers.push({ text: 'CGST', value: 'CGST', align: 'center' }, { text: 'SGST', value: 'SGST', align: 'center' })
      }
      headers.push({ text: 'Total(Incl.Tax)', value: 'includeTax', align: 'center' })
      return headers
    },
    getQRCode: async function(QRCodeString) {
      try {
        await QRCode.toDataURL(QRCodeString).then(url => {
          this.invoiceDetail.image = url
        })
        this.invoiceDetail.image1 = this.invoiceDetail.image
        this.invoiceDetail.image = await helper.convertImgToBase64(this.invoiceDetail.image)
        // QRCode.toDataURL(QRCodeString, opts1)
        //   .then(url => {
        //     this.invoiceDetail.image1 = url
        //   })
        //   .catch(err => {
        //     console.error(err)
        //   })

        // }
      } catch (e) {
        // console.log(e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getInvoiceDetails: async function() {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/royalty-invoice/${this.transactionID}`)

        this.invoiceInfo = data || {}
        this.rawData = [].concat(this.invoiceInfo)
        this.franchiseeDetails = data && data.franchiseeDetails ? data.franchiseeDetails : {}

        this.studentDetails = data.studentDetails && data.studentDetails.studentEnrollment ? data.studentDetails.studentEnrollment : {}
        if (this.invoiceInfo && this.invoiceInfo.qrCode) {
          await this.getQRCode(this.invoiceInfo.qrCode)
        }
        this.headers = this.getHeaders()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
      }
    },
    printInvoice: async function() {
      if (this.logoUrl) {
        const printContents = document.getElementById('printableArea').innerHTML
        const documentHead =
          '<!DOCTYPE html><html lang="en"><head><style>@page{margin-top:20px;margin-bottom:0px;}body{margin:0;padding:0;font-family:Consolas,arial;font-size:11px;}.invoiceTable{border:1px solid;img{width: auto; display: block;}box-sizing: border-box;border-collapse: collapse;}.invoiceTable td{border-right:1px solid;border-bottom:1px solid;box-sizing: border-box;vertical-align:top;}.invoiceTable td.noBorder{border:none;}.franchiseeTable{line-height: 1.5}</style></head><body>' +
          printContents +
          '</body></html>'
        const doc = document.getElementById('iframeReceipt').contentWindow.document
        doc.open()
        doc.write(documentHead)
        window.frames['iframeReceipt'].focus()
        window.frames['iframeReceipt'].print()
        doc.removeChild(doc.documentElement)
      }
    },
    isBefore(date1, date2) {
      let d1 = new Date(date1)
      let d2= new Date(date2)
      return d1 < d2;
    },
    conditionalCompanyName: function (date){
      let companyName = ''
      if(this.isBefore(date, '2023-11-16T00:00:00.000Z')){
        companyName = 'Brainbees Solutions Pvt Ltd'
      } else if(this.isBefore(date, '2024-04-01T00:00:00.000Z')) {
        companyName = 'Brainbees Solutions Limited (Formerly known as Brainbees Solutions Pvt Ltd)'
      } else {
        companyName = 'Brainbees Solution Limited'
      }
      return companyName
    }
  }
}
</script>
<style lang="scss" scoped>
.page_header {
  .button {
    padding: 0.35rem 0.75rem;
    height: 2rem;
  }
  .icon.is-small .mdi {
    font-size: 16px;
  }
}
.receipt_details .bill_tables .footer_table .table.leftside tr td[data-v-ac24c7a6]:nth-child(1) {
  width: 0;
}
.button.has-text-info {
  width: auto !important;
}
.msg_div {
  width: auto !important;
}
.modal_table {
  table,
  th,
  td {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid black;
    padding: 0.65rem 0.7rem;
    font-size: 1rem;
  }
  table {
    overflow-x: scroll;
    overflow-y: scroll;
  }
  td {
    display: table-cell;
    padding: 5px;
    color: black;
  }
  th {
    color: #fff;
    background-color: #56509f;
  }
}
.receipt_details {
  .receipt_heading {
    font-size: 1.3rem;
    font-weight: bold;
  }
  .sub_headings {
    color: seagreen;
  }
  .title.is-5 {
    color: black;
  }
  .hr_yellow {
    background-color: #191d38;
    height: 0.3rem;
  }
  .border_dashed {
    border-left: 1px dashed gray;
  }
  .customer_details,
  .franchisee_details {
    th {
      width: 10rem;
    }
    .table td,
    .table th {
      border: 0;
      padding: 0.3em 0.75em;
    }
  }
  .bill_tables {
    .table th {
      border: 1px solid #9a9a9a;
      background-color: #191d38;
      color: white;
      padding: 0.8em 0.75em;
    }
    .table td {
      padding: 0.8em 0.75em;
      border: 0.5px solid #9a9a9a;
    }
    caption {
      padding: 0.75rem;
      font-size: 1rem;
    }
    .footer_table {
      padding: 0 !important;
      .table td {
        padding: 0.25rem 0.4rem;
        border: 1px lightcyan;
      }
      .table.rightside tr {
        td {
          text-align: right;
        }
      }
      .table.leftside tr {
        // td:nth-child(1) {
        //   width: 12rem;
        // }
        td:nth-child(2) {
          padding-left: 1.5rem;
          width: 5rem;
        }
      }
    }
  }
}
</style>
